import Cookie from 'js-cookie';

class Latch {

    constructor() {
        try {
            if(Cookie.get('jb-latches'))
                this.latches = JSON.parse(Cookie.get('jb-latches'));
            else
                this.latches = {};
        } catch(e) {
            this.latches = {};
            this.save();
        }
    }

    save() {
        Cookie.set('jb-latches', JSON.stringify(this.latches));
    }

    has(name) {
        if(this.latches[name]) {
            return true;
        }
        return false;
    }

    did(name) {
        this.latches[name] = true;
        this.save();
    }

    reset(name) {
        if(this.latches[name]) {
            delete this.latches[name];
            this.save();
        } 
    }

}

var latch = new Latch();
export default latch;


// WEBPACK FOOTER //
// ./scripts/modules/notify-latch.js